/* jscs:disable disallowFunctionDeclarations*/
(function(){
  'use strict';

  angular
    .module('AcaApp')
    .directive('ngHistoryStatus', NgHistoryStatus);

  NgHistoryStatus.$inject = [
    'HIST_STATUS_TEXT',
    'ManagedUserInformationService'
  ];

  function NgHistoryStatus(HIST_STATUS_TEXT, ManagedUserInformationService){
    return {
      scope: {
        parent: '=',
        currentPage: '=',
        onClickRow: '&',
        goToReview: '&',
        editXmitState: '&',
        currentArray: '=',
        canEdit: '=',
      },
      templateUrl: 'app/views/common/directives/historyStatus/main.html',
      link: function(scope){
        switch(scope.parent){
          case HIST_STATUS_TEXT.PARENTIMPORT:
            scope.moduleTitle = HIST_STATUS_TEXT.MODULETITLEIMPORT;
            break;
          case HIST_STATUS_TEXT.PARENTTRANSMITTAL:
            scope.moduleTitle = HIST_STATUS_TEXT.MODULETITLETRANSMITTAL;
            break;
          case HIST_STATUS_TEXT.PARENTPRINT:
            scope.moduleTitle = HIST_STATUS_TEXT.MODULETITLEPRINT;
            break;
          case HIST_STATUS_TEXT.PARENTSTATETRANSMITTAL:
              scope.moduleTitle = HIST_STATUS_TEXT.MODULETITLESTATETRANSMITTAL;
              break;
        }

        scope.goBack = function(){
          switch(scope.parent){
            case HIST_STATUS_TEXT.PARENTIMPORT:
              scope.currentPage.importPage = HIST_STATUS_TEXT.GOBACKTOIMPORT;
              break;
            case HIST_STATUS_TEXT.PARENTSTATETRANSMITTAL:
            case HIST_STATUS_TEXT.PARENTTRANSMITTAL:
              if(ManagedUserInformationService.isManagedServicesAndNotSovosProfile()){
                ManagedUserInformationService.checkManagedServices('corrections');
              }
              else{
                scope.currentPage.sendPage = HIST_STATUS_TEXT.GOBACKTOSEND;
              }
              break;
            case HIST_STATUS_TEXT.PARENTPRINT:
              if(ManagedUserInformationService.isManagedServicesAndNotSovosProfile()){
                ManagedUserInformationService.checkManagedServices('printservice');
              }
              else{
                scope.currentPage.sendPage = HIST_STATUS_TEXT.GOBACKTOSEND;
              }
              break;
          }
        };

        scope.clickRow = function(message){
          scope.onClickRow({message: message});
        };

        scope.clickGoToReview = function(message){
          scope.goToReview({message: message});
        };

        scope.clickEditXmitState = function(message){
          scope.editXmitState({message: message});
        }
      }
    };
  }
})();